export const logsColumnOrder = [
  { label: 'Time', key: 'time', size: 'cell-md-1' },
  { label: 'Updated by', key: 'updated', size: 'cell-md-2' },
  { label: 'Event', key: 'event', size: 'cell-md-1' },
  { label: 'Change', key: 'change', size: 'cell-md-8' },
]

export const logsColumnOrderCondensed = [
  { label: 'Updated', key: 'updated', size: 'cell-xs-1 cell-md-2' },
  { label: 'Event', key: 'event', size: 'cell-xs-1 cell-md-1' },
  { label: 'Change', key: 'change', size: 'cell-xs-10 cell-md-9' },
]
